<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </template>
      <template #extra>
        <vxe-button :disabled="item.isNew()" content="button.reset" icon="vxe-icon-undo" mode="text" status="danger" @click="refresh(item.id)"/>
        <vxe-button content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
      </template>
      <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="item" :rules="rules" :wrapper-col="wrapperCol">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.itemNo')" prop="no">
              <vxe-input v-model="item.no" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.ChineseName')" prop="name">
              <vxe-input v-model="item.name" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.englishName')">
              <vxe-input v-model="item.englishName" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.universalName')">
              <vxe-input v-model="item.universalName" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.owner')">
              <vxe-select v-model="ownerIds" :options="owners" multiple style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.manufacturer')" prop="manufacturer">
              <vxe-input v-model="item.manufacturer" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.producingArea')">
              <vxe-input v-model="item.producingArea" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.approvalNo')">
              <vxe-input v-model="item.approval" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.license')">
              <vxe-input v-model="item.license" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.permission')">
              <vxe-input v-model="item.permission" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.practice')">
              <vxe-input v-model="item.practice" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.quality')">
              <vxe-input v-model="item.quality" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.itemBarcode')">
              <vxe-input v-model="item.barcodes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.permitHolder')">
              <vxe-input v-model="item.permitHolder" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.patentNum')">
              <vxe-input v-model="item.patentNum" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.patentDay')">
              <vxe-input v-model="item.patentDay" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.itemType')" prop="itemType">
              <vxe-select v-model="item.itemType.id" :options="itemTypes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.itemCategory')" prop="itemCategory">
              <vxe-select v-model="item.itemCategory.id" :options="itemCategories" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.legalAttribute')">
              <vxe-select v-model="item.legalAttribute.id" :options="legalAttributes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.brand')">
              <vxe-select v-model="item.brand.id" :options="brands" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.season')">
              <vxe-select v-model="item.season.id" :options="seasons" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.dataSource')" prop="dataSource">
              <vxe-select v-model="item.dataSource" :options="dataSources" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.abcClassification')" prop="saleClassification">
              <vxe-select v-model="item.saleClassification" :options="saleClassifications" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.storageClassification')" prop="storageClassification">
              <vxe-select v-model="item.storageClassification" :options="storageClassifications" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.turnoverMode')" prop="turnoverMode">
              <vxe-select v-model="item.turnoverMode" :options="turnoverModes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.storageEnvironment')">
              <vxe-select v-model="item.storageEnvironment" :options="storageEnvironments" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.storageRequest')">
              <vxe-select v-model="item.storageRequest.id" :options="storageRequests" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.dosageForm')">
              <vxe-select v-model="item.dosageForm.id" :options="dosageForms" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.roundingMode')">
              <vxe-select v-model="item.roundingMode" style="width: 100%">
                <vxe-option label="向上取整" value="2"/>
                <vxe-option label="向下取整" value="3"/>
              </vxe-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.supervisionCodeInitial')">
              <vxe-input v-model="item.supervisingBarcodeInitial" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.supervisionCodeLength')">
              <vxe-number-input v-model="item.supervisingBarcodeLength" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.outboundNumberOfLot')">
              <vxe-number-input v-model="item.numberOfLot" :max="9" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.supplyQuantity')">
              <vxe-number-input v-model="item.numberOfSupply" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.daysOfProductionNearly')">
              <vxe-number-input v-model="item.daysOfProductionNearly" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.daysOfExpirationNearly')">
              <vxe-number-input v-model="item.daysOfExpirationNearly" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.daysOfInspectionNearly')">
              <vxe-number-input v-model="item.daysOfInspectionNearly" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.daysOfMaintenanceNearly')">
              <vxe-number-input v-model="item.daysOfMaintenanceNearly" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.separationOfLabel')">
              <vxe-number-input v-model="item.separationOfLabel" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.deviation')">
              <vxe-number-input v-model="item.deviation" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.tagPrice')">
              <vxe-number-input v-model="item.tagPrice" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.retailPrice')">
              <vxe-number-input v-model="item.retailPrice" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.wholesalePrice')">
              <vxe-number-input v-model="item.wholesalePrice" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.costPrice')">
              <vxe-number-input v-model="item.costPrice" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.purchasePrice')">
              <vxe-number-input v-model="item.purchasePrice" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.available')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.available" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.approved')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.approved" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.newProduct')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.newProduct" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.coldStorage')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.refrigeration" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.valuable')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.valuable" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.importation')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.importation" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.psychotropic')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.psychotropic" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.psychotropic2')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.psychotropic2" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.special')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.special" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.specialIngredient')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.specialIngredient" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.peptides')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.peptides" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.gift')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.gift" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.abnormality')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.abnormality" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.fragile')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.fragile" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.hazardous')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.hazardous" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.liquid')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.liquid" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.fallible')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.fallible" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.perishable')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.perishable" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.approvalConfirm')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.approvalConfirm" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.lotControl')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.lotControl" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.autoAccepting')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.autoAccepting" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.autoPutaway')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.autoPutaway" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.scattered')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.scattered" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.duplex')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.duplex" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.visualized')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.visualized" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="3">
            <a-form-model-item :label="$t('business.label.supervised')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="item.supervised" size="mini"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col :span="12">
            <a-form-model-item :label="$t('business.label.storageNotes')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
              <vxe-textarea v-model="item.storageNotes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('business.label.checkContents')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
              <vxe-textarea v-model="item.checkContents" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { ENTERPRISE } from '@/store/mutation-types'
import { findOne, save } from '@/api/Api'
import { Item } from '@/api/dto/common/Item'

export default {
  name: 'ItemDetail',
  props: {
    owners: { type: Array, default: [] },
    itemTypes: { type: Array, default: [] },
    itemCategories: { type: Array, default: [] },
    legalAttributes: { type: Array, default: [] },
    brands: { type: Array, default: [] },
    seasons: { type: Array, default: [] },
    dataSources: { type: Array, default: [] },
    saleClassifications: { type: Array, default: [] },
    storageClassifications: { type: Array, default: [] },
    turnoverModes: { type: Array, default: [] },
    storageEnvironments: { type: Array, default: [] },
    storageRequests: { type: Array, default: [] },
    dosageForms: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      enterprise: Vue.ls.get(ENTERPRISE),
      item: new Item(),
      ownerIds: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        no: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        name: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        manufacturer: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        itemType: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        itemCategory: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        saleClassification: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        storageClassification: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        turnoverMode: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    build(result) {
      this.item = new Item(result)
      this.ownerIds = result && result.owners ? result.owners.map(item => item.id) : []
    },
    refresh(id, copy) {
      this.loading = true
      findOne('itemFactory', { id: id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.build(res.result)
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.build()
      this.item.available = true
      this.item.approved = true
      this.item.dataSource = 4
    },
    save() {
      this.$refs.form.validate((success) => {
        if (success) {
          this.loading = true
          const item = this.item.toJSONObject()
          item.enterprise = this.enterprise
          item.owners = this.ownerIds ? this.ownerIds.map(item => {
            return { id: item }
          }) : []
          save('itemPersister', item).then(res => {
            if (res.success) {
              this.build(res.result)
              this.$message.success(this.$t('message.saveSuccess'))
            }
          }).finally(() => this.loading = false)
        }
      })
    }
  }
}
</script>